import React, { Component } from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import LeadUpdateModalUI from './LeadUpdateModalUI';

class LeadUpdateModalSF extends Component {
  constructor(props) {
    super(props);

    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      email: '',
      emailError: null,
      leadName: '',
      leadNameError: null,
      channel: '',
      channelError: null,
      ownerUserId: '',
      ownerUserIdError: null,
      supportOwnerUserId: '',
      supportOwnerUserIdError: null,
    };
  }

  render() {
    return (
      <LeadUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        //event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelLeadUpdate}
        //modes
        leadUpdateMode={this.props.leadUpdateMode}
        submitted={this.state.submitted}
        //form fields
        //email
        email={this.state.email}
        onEmailChange={(event) => this.setState({ email: event.target.value })}
        emailError={this.state.emailError}
        setEmailError={(error) => this.setState({ emailError: error })}
        //name
        leadName={this.state.leadName}
        onLeadNameChange={(event) => this.setState({ leadName: event.target.value })}
        leadNameError={this.state.leadNameError}
        setLeadNameError={(error) => this.setState({ leadNameError: error })}
        //channel
        channel={this.state.channel}
        onChannelChange={(event) => this.setState({ channel: event.target.value })}
        channelError={this.state.channelError}
        setChannelError={(error) => this.setState({ channelError: error })}
        filteredSalesChannelList={this.props.filteredSalesChannelList}
        // owner user ID
        ownerUserId={this.state.ownerUserId}
        onOwnerUserIdChange={(event) => this.setState({ ownerUserId: event.target.value })}
        ownerUserIdError={this.state.ownerUserIdError}
        setOwnerUserIdError={(error) => this.setState({ ownerUserIdError: error })}
        // support owner user ID
        supportOwnerUserId={this.state.supportOwnerUserId}
        onSupportOwnerUserIdChange={(event) => this.setState({ supportOwnerUserId: event.target.value })}
        supportOwnerUserIdError={this.state.supportOwnerUserIdError}
        setSupportOwnerUserIdError={(error) => this.setState({ supportOwnerUserIdError: error })}
        //
        salesChannelList={this.props.salesChannelList}
        ownerUserList={this.props.ownerUserList}
        supportOwnerUserList={this.props.supportOwnerUserList}
      />
    );
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (!prevProps || !this.props.lead)
      return
    if (prevProps.lead && prevProps.lead.leadId === this.props.lead.leadId)
      return
    this.setState({ leadName: this.props.lead.leadName, email: this.props.lead.email })
  }

  onCancelLeadUpdate = () => {
    this.setState({
      successMsg: null,
      errorList: null,
      channel: null,
      ownerUserId: null,
      supportOwnerUserId: null,
    });
    this.props.onCancelLeadUpdate();
  };

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true,
    });

    RestApiUtils.put(
      this.props.context,
      `/api/su/leads/${this.props.lead.leadId}`,
      this.onSubmitCallback,
      {
        email: this.state.email,
        leadName: this.state.leadName,
        channel: this.state.channel,
        ownerUserId: this.state.ownerUserId,
        supportOwnerUserId: this.state.supportOwnerUserId,
      }
    );
  };

  onSubmitCallback = (response) => {
    let errorList = [];
    if (response && response.errorList) {
      response.errorList.forEach((error) => {
        errorList.push(error.message)
      });
    }


    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false,
    });

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onCancelLeadUpdate()
        this.props.onRefreshClick()
      }, 2000);
    }
  };

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  };
}

export default withRouter(LeadUpdateModalSF)
